module.exports={
	"Form": "LotViewManifest",
	"Scope": "Lot-View",
	"Descriptors":
	{
		"LotDetails.Name":
		{
			"Name": "Name",
			"Hash": "Lot-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "Lot-View-Identity",
				"Group": "Lot-View-Identity"
			}
		},
		"LotDetails.StartDate":
		{
			"Name": "Start Date",
			"Hash": "Lot-View-StartDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Lot-View-Details",
				"Group": "Lot-View-Details"
			}
		},
		"LotDetails.FormData":
		{
			"Name": "Form Data",
			"Hash": "Lot-View-FormData",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "Lot-View-Details",
				"Group": "Lot-View-Details"
			}
		},
		"LotDetails.IDMixDesign":
		{
			"Name": "Mix Design",
			"Hash": "Lot-View-IDMixDesign",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "Lot-View-Details",
				"Group": "Lot-View-Details",
				"Entity": "MixDesign",
				"SearchFields":
				[
					"MaterialCode",
					"Name",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"LotDetails.IDContract":
		{
			"Name": "Contract",
			"Hash": "Lot-View-IDContract",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "3",
				"Width": 4,
				"Section": "Lot-View-Details",
				"Group": "Lot-View-Details",
				"Entity": "Contract",
				"SearchFields":
				[
					"Name",
					"Description",
					"PrimaryProjectNumber",
					"CountyProjectNumber"
				],
				"ReadOnly": true
			}
		},
		"LotDetails.ValidationSequence":
		{
			"Name": "Validation Sequence",
			"Hash": "Lot-View-ValidationSequence",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "Lot-View-Details",
				"Group": "Lot-View-Details"
			}
		},
		"LotDetails.LPSyncDate":
		{
			"Name": "LPSync Date",
			"Hash": "Lot-View-LPSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "Lot-View-Details",
				"Group": "Lot-View-Details"
			}
		},
		"LotDetails.HLSyncDate":
		{
			"Name": "HLSync Date",
			"Hash": "Lot-View-HLSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "Lot-View-Details",
				"Group": "Lot-View-Details"
			}
		},
		"LotDetails.IDLot":
		{
			"Name": "IDLot",
			"Hash": "Lot-View-IDLot",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Lot-View-DataAudit",
				"Group": "Lot-View-DataAudit"
			}
		},
		"LotDetails.GUIDLot":
		{
			"Name": "GUIDLot",
			"Hash": "Lot-View-GUIDLot",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Lot-View-DataAudit",
				"Group": "Lot-View-DataAudit"
			}
		},
		"LotDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Lot-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "Lot-View-DataAudit",
				"Group": "Lot-View-DataAudit"
			}
		},
		"LotDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Lot-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Lot-View-DataAudit",
				"Group": "Lot-View-DataAudit"
			}
		},
		"LotDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Lot-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Lot-View-DataAudit",
				"Group": "Lot-View-DataAudit"
			}
		},
		"LotDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Lot-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "Lot-View-DataAudit",
				"Group": "Lot-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Lot-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Lot-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Lot-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Lot-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Lot-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Lot-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
